export const Rols = {
    user: 0,
    superadmin: 1,
    admin: 2,
    viewer: 3,
}
